import gsap from 'gsap';
import { LogoMark } from './LogoMark';
import { DataManager } from '../../data/DataManager';
import { LogoMarkControl0 } from './LogoMarkControl0';


export class LogoMarkControl extends LogoMarkControl0{

    

    public init(logo:LogoMark){

        if(this.isInit)return;
        this.isInit=true;

        this.count=0;
        this.strokes = logo.strokes;
        this.mojis = DataManager.getInstance().mojis;
        this.logo = logo;
        this.logoMesh = logo.markMesh;

        super.resetBaseDots(true);
        super.resetCount();

    }

    //消す
    public Hide(callback:()=>void){
        
        this.callbackHide=callback;
        this.enabled=true;
        this.hideFillLogo();

    }

    private hideFillLogo(){
        
        console.log('hideFillLogo!!');

        this.logoMesh.hideBg();
        this.logoMesh.showAllDots();
        
        this.isShowing=false;

        this.mojis.changeNum(0,0);//一回間引いた状態に
        
        this.resetBaseDots(false);//dots配列を再計算
        
        super.setBgDotsEnabled(false);//消す
        super.resetCount();//カウント終了

        //this.mojis

        this.count=0;
        gsap.to(this,{
            count: this.logoDots.length,
            duration: 4,
            ease: "power3.inOut",//power2.out",
            onComplete:()=>{
                this.callbackHide();
            }
        });

    }






    public update(){

        if( this.enabled ){

            if(this.isShowing){
                super.updateShowLogoDots();//ロゴを出す
            }else{
                this.updateHideLogoDots();//ロゴ消す、背景を出す
            }
    
        }
    
    }

    //カウンターを二つ作る
    //増えるものと減るもの

    //背景の表示
    private updateHideLogoDots(){

        //console.log(this.count+"/"+this.bgDots.length);
        for(let i=0;i<this.count;i++){
            let logoDot = this.logoDots[i];//ロゴドットを主役にする。

            if(logoDot){
                let len = logoDot.tgtIndex.length;
                for(let j=0;j<len;j++){//ロゴドットにリンクされてるbgを対象に
                    
                    let bgIndex = logoDot.tgtIndex[j];
                    let bgDot = this.bgDots[ bgIndex ];
                    
                    if(logoDot.enabled){
                        //console.log(bgIndex,this.bgDots.length,this.logoDots.length)
                        let limit = 20*len+10*Math.random();
                        this.strokes.connectDots(
                            bgDot.v.x,bgDot.v.y,bgDot.v.y,
                            logoDot.v.x,logoDot.v.y,logoDot.v.z,
                            1-logoDot.count/limit
                        );

                        if(!bgDot.enabled)bgDot.scale=1.8;
                        bgDot.enabled=true;
                        
                        logoDot.count++;
                        if(logoDot.count>limit){
                            logoDot.enabled=false;
                        }
                        bgDot.enabled=true;
                        
                    }
                    
                }
            }
        }

    }

    
}


